<!-- svelte-ignore a11y-missing-content -->
<!-- svelte-ignore a11y-missing-attribute -->

<script context="module">

    export const VideoDefaults = {
        "name": "video",

        "outer-container": { 
            "style": {
                "text-align": "center",
                "align-items": "center",
                "z-index": "5",
            }
        },
        "inner-container": {
            "style": {
                "width": "100%"
            }
        },
        "video": {
            "name": "video",
            "style": {
                "width": "100%", 
                "height": "auto", 
                "border-radius": "0px",
            },
            "src": "https://assets.website-files.com/5c34b1d990599d63c8b3e892/61256d3fe8179db3828945e3_paywall_test_2-transcode.mp4"
        },
        "meta": {
            "order": {
                "video": 1,
            }
        }
    }
    
</script>

<script>


</script>


<video autoplay="true" loop="true" style="" muted="true" playsinline="true" data-object-fit="cover" data-i-name="video"/>

<style> 

</style>